import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormInputCheckbox } from '../../inputs/FormInputCheckbox';

interface BonusPointsCheckboxProps {
  onChange: (e: boolean) => void;
  isBonus?: boolean;
}

const BonusPointsCheckbox: FC<BonusPointsCheckboxProps> = ({ onChange, isBonus = false }) => {
  const { t } = useTranslation();
  return (
    <FormInputCheckbox
      defaultChecked={isBonus}
      name="useBonusPoints"
      label={t('servicePayment.useBonusPoints')}
      onChange={onChange}
    />
  );
};

export default memo(BonusPointsCheckbox);
